module.exports = __webpack_public_path__ + "img/bangladesh.f596f89.webp";